import backed_by_research_icon from "../assets/icons/mind.png";
import ancient_root_icon from "../assets/icons/trailor-made.png";
import travel_wisdom_icon from "../assets/icons/travel-wisdom.png";

import twenty47_icon from "../assets/icons/24-hours (2).png"
import airTravel_icon from "../assets/icons/air travel.png"
import travelInsurance_icon from "../assets/icons/travel insurance.png"

const contentData = [
  {
    img: twenty47_icon,
    title: "24x7 Service",
    sub: "Rely on our 24/7 service to ensure you are looked after at every step, ultimately guiding you to fully immerse yourself in the beauty of your mindfulness journey.",
  },
  {
    img: travelInsurance_icon,
    title: "Travel Insurance",
    sub: "Our holiday packages offer more than just relaxation and adventure. With comprehensive insurance, you can embark on your mindful journey worry-free.",
  },
  {
    img: airTravel_icon,
    title: "Air Travel/Tickets",
    sub: "We enhance your mindful journey with comprehensive services. From meditation programs to convenient air ticketing, we ensure a seamless Sri Lankan experience.",
  },
  {
    img: backed_by_research_icon,
    title: "Mindfulness Coaching",
    sub: "NTT Leisure offers introspective coaching and workshops to alleviate stress, rooted in academic research on personal growth and leadership.",
  },
  {
    img: ancient_root_icon,
    title: "Tailor made Tours",
    sub: "Each location has been carefully chosen to represent where these profound practices have been established and where they continue to thrive.",
  },
  {
    img: travel_wisdom_icon,
    title: "Travel Wisdom",
    sub: "With our team of travel experts, your mindfulness vacation will be managed with the highest level of expertise and care.",
  },
];

export default contentData;